export { default } from './MyCertificate';
